module.exports = __webpack_public_path__ + "static/media/codeq.28df2bbe.svg";